import { render, staticRenderFns } from "./FieldPhoneWithNote.vue?vue&type=template&id=336bbd30&scoped=true"
import script from "./FieldPhoneWithNote.vue?vue&type=script&lang=js"
export * from "./FieldPhoneWithNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336bbd30",
  null
  
)

export default component.exports